import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export class BenefitItem {
    public key: string = '';
    public value: string = '';
}

export interface IBenefit {
    benefits: BenefitItem[];
    statement?: string;
}

export class Benefit {
    @observable public benefits: BenefitItem[] = [];
    @observable public statement: string = '';

    public static fromJson(benefit: IBenefit): Benefit {
        const newBenefit = new Benefit();
        if (!benefit) {
            return newBenefit;
        }
        copyPropertiesExcludeNullsAndGetters(newBenefit, benefit);

        if (benefit.benefits) {
            newBenefit.benefits = benefit.benefits.map((item) => {
                const benefitItem = new BenefitItem();
                copyPropertiesExcludeNullsAndGetters(benefitItem, item);

                return benefitItem;
            });
        }

        return newBenefit;
    }
}
